module.exports = __webpack_public_path__ + "static/media/image13.b085a6f3.jpg";